/* eslint-disable react/no-danger */
import '../styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import track from 'react-tracking';
import { Container } from '@edx/paragon';

import AtAGlance from '../../AtAGlance';
import CourseSnapshot from '../../CourseSnapshot';

function CourseMainMobile({
  course,
  course: {
    fullDescription,
  },
  programs,
  paymentOption,
}) {
  return (
    <Container size="sm" className="course-main">
      <CourseSnapshot
        {...course}
        paymentOption={paymentOption}
      />
      <div className="mt-2 lead-sm html-data" dangerouslySetInnerHTML={{ __html: fullDescription }} />
      <AtAGlance
        {...course}
        programs={programs}
      />
    </Container>
  );
}

CourseMainMobile.propTypes = {
  course: PropTypes.shape({
    fullDescription: PropTypes.string,
    syllabusRaw: PropTypes.string,
  }).isRequired,
  programs: PropTypes.arrayOf(PropTypes.shape({})),
  paymentOption: PropTypes.string.isRequired,
};

CourseMainMobile.defaultProps = {
  programs: [],
};

export default track({
  component: 'course-main-exp',
})(CourseMainMobile);
